import React from 'react';
import styled from 'styled-components';
import Link from 'gatsby-link';
import LinksList from './LinksList';

const LinksDiv = styled.div`
  order: 1;
  @media (max-width: 700px) {
    display: none;
  }
  width: 20rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export default () => (
  <LinksDiv>
    <LinksList />
  </LinksDiv>
);



// WEBPACK FOOTER //
// ./src/components/Header/DeskTopLinks.js